import React from 'react'
import Heading from './heading'
import { Route } from 'react-router'

import Users from './users'
import Companies from './companies'
import MyAccount from './my-account'

export default () => (
  <div>
    <Heading />
    <Route
      exact
      path="/settings"
      component={MyAccount}
    />

    <Route
      path="/settings/users"
      component={Users}
    />

    <Route
      path="/settings/companies"
      component={Companies}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/views/settings/index.js